/*
  Watches for changes in redux and syncs window.digitalData
 */

import { Component } from "react";
import lodashIsEqual from "lodash.isequal";
import lodashGet from "lodash.get";
import lodashCloneDeep from "lodash.clonedeep";
import AnalyticsContext from "../analytics-context";

class DdlManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      analytics: {
        ddlIsDirty: false
      }
    };
  }

  syncDigitalData = props => {
    const isDirty = !lodashIsEqual(
      this.context.digitalData,
      props.window.digitalData
    );

    if (isDirty) {
      window.digitalData = lodashCloneDeep(this.context.digitalData);
      this.context.actions.ddlIsDirty(false);
    }
  };

  componentDidMount() {
    this.syncDigitalData(this.props);
  }

  // Check if there are differences between redux and window objects
  componentDidUpdate() {
    this.syncDigitalData(this.props);
  }

  render() {
    return null;
  }
}

DdlManager.contextType = AnalyticsContext;

DdlManager.defaultProps = {
  // eslint-disable-next-line no-undef
  window: lodashGet(global, "window")
};

export default DdlManager;
